import React from 'react';

export const FaceFrustrationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M12.5 5C12.7761 5 13 5.22386 13 5.5C13 6.63568 12.5691 7.52418 11.8947 8.1237C11.2294 8.71505 10.3565 9 9.5 9C9.22386 9 9 8.77614 9 8.5C9 8.22386 9.22386 8 9.5 8C10.1435 8 10.7706 7.78495 11.2303 7.3763C11.6809 6.97582 12 6.36432 12 5.5C12 5.22386 12.2239 5 12.5 5Z"
        fill="#402A32"
      />
      <path
        d="M13.8944 11.4472C14.1414 10.9532 13.9412 10.3526 13.4472 10.1056C12.9532 9.85858 12.3526 10.0588 12.1056 10.5528C11.7578 11.2484 10.9746 11.7372 10.0185 11.8751C9.04949 12.0149 8.17005 11.7558 7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071C7.32995 13.7442 8.91558 14.0549 10.3041 13.8547C11.7055 13.6525 13.1724 12.8913 13.8944 11.4472Z"
        fill="#402A32"
      />
      <path
        d="M18.1056 11.4472C17.8586 10.9532 18.0588 10.3526 18.5528 10.1056C19.0468 9.85858 19.6474 10.0588 19.8944 10.5528C20.2422 11.2484 21.0254 11.7372 21.9815 11.8751C22.9505 12.0149 23.83 11.7558 24.2929 11.2929C24.6834 10.9024 25.3166 10.9024 25.7071 11.2929C26.0976 11.6834 26.0976 12.3166 25.7071 12.7071C24.67 13.7442 23.0844 14.0549 21.6959 13.8547C20.2945 13.6525 18.8276 12.8913 18.1056 11.4472Z"
        fill="#402A32"
      />
      <path
        d="M19 5.5C19 5.22386 19.2239 5 19.5 5C19.7761 5 20 5.22386 20 5.5C20 6.36432 20.3191 6.97582 20.7697 7.3763C21.2294 7.78495 21.8565 8 22.5 8C22.7761 8 23 8.22386 23 8.5C23 8.77614 22.7761 9 22.5 9C21.6435 9 20.7706 8.71505 20.1053 8.1237C19.4309 7.52418 19 6.63568 19 5.5Z"
        fill="#402A32"
      />
      <path
        d="M10.3427 18C8.67067 19.353 7.49311 21.2929 7.12339 23.5063C6.9869 24.3234 7.67127 25 8.4997 25H23.5003C24.3287 25 25.0131 24.3234 24.8766 23.5063C24.5069 21.2929 23.3293 19.353 21.6573 18L16 17L10.3427 18Z"
        fill="#BB1D80"
      />
      <path
        d="M21.6574 18H10.3428C11.8885 16.7492 13.8568 16 16.0001 16C18.1434 16 20.1117 16.7492 21.6574 18Z"
        fill="white"
      />
    </svg>
  );
};
